import useText from '@/hooks/useText';
import { ACADEMIC_MODAL_TEXTS } from '../constants/academicModalTexts';

export function useAcademicModalTexts() {
  return {
    accExpiredNoticeTitle: useText(ACADEMIC_MODAL_TEXTS.accExpiredNoticeTitle),
    accExpiredNoticeText: useText(ACADEMIC_MODAL_TEXTS.accExpiredNoticeText),
    accExpiredNoticeDisclaimer: useText(ACADEMIC_MODAL_TEXTS.accExpiredNoticeDisclaimer),
    accExpiredRenewBtn: useText(ACADEMIC_MODAL_TEXTS.accExpiredRenewBtn),
    accExpiredCancelBtn: useText(ACADEMIC_MODAL_TEXTS.accExpiredCancelBtn),
    accExpiredRemindBtn: useText(ACADEMIC_MODAL_TEXTS.accExpiredRemindBtn),
    swalTermsTitle: useText(ACADEMIC_MODAL_TEXTS.swalTermsTitle),
    swalTermsText: useText(ACADEMIC_MODAL_TEXTS.swalTermsText),
    swalRenewalSubmittedTitle: useText(ACADEMIC_MODAL_TEXTS.swalRenewalSubmittedTitle),
    swalRenewalSubmittedText: useText(ACADEMIC_MODAL_TEXTS.swalRenewalSubmittedText),
    swalConfirmCancelTitle: useText(ACADEMIC_MODAL_TEXTS.swalConfirmCancelTitle),
    swalConfirmCancelText: useText(ACADEMIC_MODAL_TEXTS.swalConfirmCancelText),
    swalConfirmCancelBtn: useText(ACADEMIC_MODAL_TEXTS.swalConfirmCancelBtn),
    swalKeepAccountBtn: useText(ACADEMIC_MODAL_TEXTS.swalKeepAccountBtn),
    swalAccountCancelledTitle: useText(ACADEMIC_MODAL_TEXTS.swalAccountCancelledTitle),
    swalErrorTitle: useText(ACADEMIC_MODAL_TEXTS.swalErrorTitle),
    swalOkBtn: useText(ACADEMIC_MODAL_TEXTS.swalOkBtn),
    modalWaitingConfirmationTitle: useText(ACADEMIC_MODAL_TEXTS.modalWaitingConfirmationTitle),
    modalWaitingConfirmationMessage: useText(ACADEMIC_MODAL_TEXTS.modalWaitingConfirmationMessage),
    modalReviewingTitle: useText(ACADEMIC_MODAL_TEXTS.modalReviewingTitle),
    modalReviewingMessage: useText(ACADEMIC_MODAL_TEXTS.modalReviewingMessage),
    modalAccountCancelledTitle: useText(ACADEMIC_MODAL_TEXTS.modalAccountCancelledTitle),
    modalAccountCancelledMessage: useText(ACADEMIC_MODAL_TEXTS.modalAccountCancelledMessage),
    modalRenewalDeniedTitle: useText(ACADEMIC_MODAL_TEXTS.modalRenewalDeniedTitle),
    modalRenewalDeniedMessage: useText(ACADEMIC_MODAL_TEXTS.modalRenewalDeniedMessage),
    modalRenewalApprovedTitle: useText(ACADEMIC_MODAL_TEXTS.modalRenewalApprovedTitle),
    modalRenewalApprovedMessage: useText(ACADEMIC_MODAL_TEXTS.modalRenewalApprovedMessage),
    modalExpiredTitle: useText(ACADEMIC_MODAL_TEXTS.modalExpiredTitle),
    modalExpiredGraceMessage: useText(ACADEMIC_MODAL_TEXTS.modalExpiredGraceMessage),
    modalExpiredNoGraceMessage: useText(ACADEMIC_MODAL_TEXTS.modalExpiredNoGraceMessage),
    modalCriticalTitle: useText(ACADEMIC_MODAL_TEXTS.modalCriticalTitle),
    modalCriticalMessage: useText(ACADEMIC_MODAL_TEXTS.modalCriticalMessage),
    modalUpgradeTitle: useText(ACADEMIC_MODAL_TEXTS.modalUpgradeTitle),
    modalUpgradeMessage: useText(ACADEMIC_MODAL_TEXTS.modalUpgradeMessage),
    btnViewPlans: useText(ACADEMIC_MODAL_TEXTS.btnViewPlans),
    btnContactSupport: useText(ACADEMIC_MODAL_TEXTS.btnContactSupport),
    btnCheckEmailStatus: useText(ACADEMIC_MODAL_TEXTS.btnCheckEmailStatus),
    btnNoEmail: useText(ACADEMIC_MODAL_TEXTS.btnNoEmail),
    btnUpgradePlan: useText(ACADEMIC_MODAL_TEXTS.btnUpgradePlan),
    btnProcessing: useText(ACADEMIC_MODAL_TEXTS.btnProcessing),
    btnDismiss: useText(ACADEMIC_MODAL_TEXTS.btnDismiss),
    licenseAcceptPrefix: useText(ACADEMIC_MODAL_TEXTS.licenseAcceptPrefix),
    licenseLinkText: useText(ACADEMIC_MODAL_TEXTS.licenseLinkText),
  };
}
